/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserIdDto
 */
export interface UserIdDto {
    /**
     * 
     * @type {string}
     * @memberof UserIdDto
     */
    username: string;
}

/**
 * Check if a given object implements the UserIdDto interface.
 */
export function instanceOfUserIdDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;

    return isInstance;
}

export function UserIdDtoFromJSON(json: any): UserIdDto {
    return UserIdDtoFromJSONTyped(json, false);
}

export function UserIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function UserIdDtoToJSON(value?: UserIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
    };
}

